/**
 * Renders `text` as individually speakable word spans.
 * When speech is unsupported renders plain text with no handlers or visual change.
 * Whitespace is preserved; leading/trailing Unicode punctuation is stripped before speak().
 */
export default function ClickableText({
  text,
  speak,
  isSpeechSupported,
}: {
  text: string
  speak: (word: string) => void
  isSpeechSupported: boolean
}) {
  if (!isSpeechSupported) return <>{text}</>
  const tokens = text.split(/(\s+)/)
  return (
    <>
      {tokens.map((token, i) =>
        /^\s+$/.test(token) ? (
          // Prevent focus theft on whitespace taps (ADR-013/014 keyboard-stays-up invariant).
          <span key={i} onPointerDown={(e) => e.preventDefault()}>{token}</span>
        ) : (
          <span
            key={i}
            // preventDefault on pointerdown prevents the browser from blurring the answer
            // input (which would retract the keyboard and cause layout drift). onClick still
            // fires because click comes from pointerup, not from the cancelled mousedown.
            onPointerDown={(e) => e.preventDefault()}
            onClick={() => {
              const clean = token.replace(/^\p{P}+|\p{P}+$/gu, '')
              if (clean) speak(clean)
            }}
            style={{ cursor: 'pointer' }}
          >
            {token}
          </span>
        )
      )}
    </>
  )
}
